export const removeObject = (list: any, obj: any) => {
  let tab: any[] = [];
  if (list?.length && obj.id) {
    tab = [...list];
    const index = tab.findIndex((t) => t?.id == obj.id);
    if (index != -1) {
      tab.splice(index, 1);
    }
  }
  return tab;
};

export const addOrUpdateObject = (list: any, obj: any) => {
  let tab: any[] = [];
  if (list?.length) {
    tab = [...list];
    if (obj?.id) {
      const index = tab.findIndex((t) => t?.id == obj.id);
      if (index == -1) {
        //Add
        tab = [obj, ...tab];
      } else {
        //Update
        tab[index] = obj;
      }
    }
  } else {
    //Add
    tab = [obj, ...tab];
  }
  return tab;
};

export const removeAllSpace = (str: string) => {
  return str.replace(/\s+/g, "").trim();
};

export const cleanedSpace = (str: string) => {
  return str.replace(/\s+/g, " ").trim();
};

export const normalizeLigatures = (text: string): string => {
  const ligatureMap: Record<string, string> = {
    œ: "oe",
    Œ: "OE",
    æ: "ae",
    Æ: "AE",
    ß: "ss",
    ẞ: "SS",
    ĳ: "ij",
    Ĳ: "IJ",
    Ǆ: "DZ",
    ǅ: "Dz",
    ǆ: "dz",
    Ǉ: "LJ",
    ǈ: "Lj",
    ǉ: "lj",
    Ǌ: "NJ",
    ǋ: "Nj",
    ǌ: "nj",
    ﬀ: "ff",
    ﬁ: "fi",
    ﬂ: "fl",
    ﬃ: "ffi",
    ﬄ: "ffl",
    ﬆ: "st",
    ﬅ: "ft",
  };

  return text.replace(
    /œ|Œ|æ|Æ|ß|ẞ|ĳ|Ĳ|Ǆ|ǅ|ǆ|Ǉ|ǈ|ǉ|Ǌ|ǋ|ǌ|ﬀ|ﬁ|ﬂ|ﬃ|ﬄ|ﬆ|ﬅ/g,
    (match) => ligatureMap[match] || match,
  );
};

export const transformNameOnCard = (_name: string) => {
  if (!_name) return;

  const name = cleanedSpace(_name);

  // Normalize accents (eg: Ê -> E, Ï -> I)
  let normalized = normalizeLigatures(
    name.normalize("NFD").replace(/[̀-ͯ]/g, ""),
  );

  // Convert to uppercase
  let transformedName = normalized.toUpperCase();

  // Remove any invalid characters (anything that is not an uppercase letter or space)
  transformedName = transformedName.replace(/[^A-Z\s]/g, "");

  // Ensure the length is between 1 and 21 characters
  if (transformedName.length > 21) {
    transformedName = transformedName.substring(0, 21);
  }

  return transformedName;
};
